"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Row = _interopRequireDefault(require("../../layout/Row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ButtonContainer = (0, _styledComponents["default"])(_Row["default"]).withConfig({
  displayName: "ButtonGroup__ButtonContainer",
  componentId: "sc-1jkx5pd-0"
})(["display:inline-flex;position:relative;button{margin:0.25rem 0.5rem;}"]);
/**
 *
 * ### A container component.
 *
 * A ButtonGroup is a container for a set buttons - although it may contain other elements if required.
 * The button group applies default `Row` styling meaning it displays its children side-by-side starting from left to right in the group.
 */

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$element = _ref.element,
      element = _ref$element === void 0 ? 'div' : _ref$element;
  return /*#__PURE__*/_react["default"].createElement(ButtonContainer, {
    element: element,
    className: className,
    gap: "small",
    padding: "none",
    role: "group"
  }, children);
};

var _default = ButtonGroup;
exports["default"] = _default;